import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useFormikContext } from "formik";
import HTMLEditor from "../../HtmlEditor/HtmlEditor";

const QuestionTextField = ({ questionFilesList, setQuestionFilesList }) => {
  const { t } = useTranslation();
  const {
    isSubmitting,
    touched,
    errors,
    values,
    setFieldValue
  } = useFormikContext();

  return (
    <Box display="flex" mt={6} flexDirection={{ xs: "column", md: "row" }}>
      <Typography variant="h5" sx={{ width: 160, mt: 0.75, mb: 3 }}>
        {t("editQuestion.textLabel")}
      </Typography>
      <Box flex={1}>
        <HTMLEditor
          height={189}
          disableMargin
          disabled={isSubmitting}
          onChange={value => {
            setFieldValue("text", value);
          }}
          onFileAdd={(fileObj, tempLink, type) => {
            const list = questionFilesList;
            list.push({ fileObj, tempLink, type });
            setQuestionFilesList(list);
          }}
          value={values.text}
          menubar={false}
          plugins={["lists", "link", "image", "media", "code"]}
          toolbar="bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist | link image media fileUpload code"
          errorMessage={touched.text && errors.text}
        />
      </Box>
    </Box>
  );
};

QuestionTextField.propTypes = {
  questionFilesList: PropTypes.array,
  setQuestionFilesList: PropTypes.func
};

export default QuestionTextField;
